/**
 * 색 계열 노출속성 지침 — 견적서 공통 속성 AI 요청이 쓴다. 의존성 없는 순수 파일(packageEstimate.js 와 같은 꼴).
 *
 * 1688 속성에 颜色 이 없으면 AI 가 상품명·재질만 보고 색을 지어냈다(2026-10-21 mircompany PR261021-2650E7 · 검정 메달걸이에 «실버»).
 * 대표이미지는 포장 크기 칸이 있을 때만 붙었고, 지침은 «입력예시 null 금지·추측 허용» 이었다.
 * → 공통 손에 색 계열이 있으면 대표이미지를 붙이고, 색 출처 차례(1688 颜色 → 대표이미지 주된 색 → 짐작 0)를 지침에 박는다.
 * 옵션 손(차별화 속성)은 옵션명 기반 그대로 — 대표이미지는 모든 옵션이 한 장에 섞여 있어 옵션 색을 가르지 못한다.
 */

// 색 계열 = 이름이 «색상» 으로 시작(잰 이름: 색상 309 · 색상계열 61 · 레포 표본 13 파일) — «색» 만 든 이름(색온도·염색 여부·탈색)은 색이 아니다
//   (cpl-x3-colorattrname-1 · #2592 saram 덧②: includes('색') 이면 색온도에 «상세페이지 참조» 가 들어가 6500K 꼴 값이 망가짐)
export function isColorAttr(name) {
  return typeof name === 'string' && name.trim().startsWith('색상')
}

/**
 * 대표이미지를 붙일까 — 포장 크기 칸(포장 형태 판단 · 옛 그대로) 또는 공통 손(colorFromImage)의 색 계열 노출속성.
 */
export function needsAttributeImage(schema, { colorFromImage = false } = {}) {
  const s = schema || {}
  if (Array.isArray(s.logisticsInfo) && s.logisticsInfo.some(info => info && info.name === 'skuUnitBoxDimension')) return true
  return !!colorFromImage && Array.isArray(s.exposedAttributes) && s.exposedAttributes.some(a => a && isColorAttr(a.name))
}

const NO_COLOR_TEXT = '상세페이지 참조'
const noColorOption = (dropdown) => dropdown.find(v => typeof v === 'string' && /기타|상세/.test(v))

/**
 * 색 계열 속성 출처 지침 — 색 계열이 없으면 ''.
 * 둘 다 못 보면: 입력예시 = «상세페이지 참조» · 드롭다운 = 그 안 기타·상세참조 값만(없으면 지어낸 값을 적지 않고 선택지 안에서 고름).
 */
export function colorSourceGuide(attrs) {
  const colors = (attrs || []).filter(a => a && isColorAttr(a.name))
  if (!colors.length) return ''
  const fallback = colors.map(a => {
    if (!Array.isArray(a.dropdown)) return `  - ${a.name}: "${NO_COLOR_TEXT}"`
    const v = noColorOption(a.dropdown)
    return v ? `  - ${a.name}: "${v}"` : `  - ${a.name}: 선택지 안에서 가장 가까운 값(지어낸 색 이름 금지)`
  }).join('\n')
  return [
    `6. **🎨 색 계열 속성(${colors.map(a => a.name).join(', ')}) — 값을 고르는 차례**:`,
    '   ① 1688 상품 속성 정보의 颜色/색상 값이 있으면 그것을 한국어로',
    '   ② 없으면 첨부한 대표이미지에서 상품 본체의 주된 색 하나',
    '   ③ 둘 다 없으면 상품명·재질로 짐작하지 말고 아래 값을 그대로:',
    fallback,
    '   - 응답의 colorSource 에 고른 출처("1688"|"image"|"none")를 색 값보다 먼저 적으세요.',
  ].join('\n')
}

export const COLOR_SOURCE_FIELD = '"colorSource": "1688|image|none 중 하나"'
